module.exports = __webpack_public_path__ + "static/media/backgroundOnboarding.0cc6bce0.png";